const EDITABLE_SHEET_EXTENSIONS = ['xlsx', 'xls', 'csv'];

/** True when the file name looks like a spreadsheet we can open in the editor. */
export const isEditableSheetFile = (fileName?: string): boolean => {
    const ext = fileName?.split('.').pop()?.toLowerCase() ?? '';
    return EDITABLE_SHEET_EXTENSIONS.includes(ext);
};

/**
 * Minimum Fortune-Sheet row height (px), applied as a floor — never shrinks a
 * row that's already taller. Fortune-Sheet's own built-in default is 19px,
 * which renders too short; named `_ROW_` (not `_CELL_`) so a sibling
 * `MIN_COLUMN_WIDTH` can be added later without a rename.
 */
export const MIN_ROW_HEIGHT = 24;

/**
 * Default Fortune-Sheet column width (px) for a column the file gives no width:
 * Excel's own default of 8.43 characters is a stored width of 9.140625, i.e.
 * trunc(7 * 9.140625 + 0.49) = 64 px at Calibri 11 / 96 dpi (the library's
 * built-in default is 73).
 */
export const DEFAULT_COL_WIDTH = 64;

// converters.ts pads every sheet's declared row/column up to this floor for
// grid usability. Kept in this dependency-free file (not converters.ts, which
// pulls in exceljs/papaparse) so sheetSizeGuard.ts's post-convert guard can
// reuse the SAME floor Fortune-Sheet is actually sized from without dragging
// converters.ts's heavier import graph into sheetSizeGuard.ts, which is
// imported directly by FileViewerDrawer, DataRoom, MagicUpload, AskAica and
// Reports.
export const MIN_ROWS = 50;
export const MIN_COLS = 26;
